import { Injectable } from '@angular/core';
import { ApiClient } from 'app/core/services/api-client';
import { ApiErrorHandlerService } from 'app/core/services/api-default-error-handler/api-error-handler.service';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  ErfassungZuweisenInput,
  UserItem,
} from 'app/core/services/api-client/api-client';

@Injectable()
export class ErfassungInfoService {
  public constructor(
    private apiClient: ApiClient,
    private errorHandler: ApiErrorHandlerService,
  ) {}

  public getAssignableUsers(erfassungId?: number | undefined): Observable<UserItem[]> {
    return this.apiClient.apiErfassungZuweisbareUserGet(erfassungId).pipe(
      catchError(
        this.apiClient.apiErfassungZuweisbareUserGetErrorHandlers({
          error401Handler: error401 => this.errorHandler.handle401Error(error401),
        })
      )
    );
  }

  public assign(erfassungId: number, input: ErfassungZuweisenInput): Observable<void> {
    return this.apiClient.apiErfassungByErfassungIdZuweisenPost(erfassungId, input).pipe(
      catchError(
        this.apiClient.apiErfassungByErfassungIdZuweisenPostErrorHandlers({
          error401Handler: error401 => this.errorHandler.handle401Error(error401),
          error404Handler: error404 => this.errorHandler.handle404Error(error404),
        }),
      ),
    );
  }
}
